import styled from 'styled-components';

export const DropdownContainer = styled.div`
  position: relative;
`;

export const DropdownButton = styled.button`
  all:unset;
  cursor: pointer;
`;

export const DropdownMenu = styled.ul`
  position: absolute;
  top: 8px;
  right: 0;
  list-style: none;
  padding: 0;
  margin: 0;
  background: ${({theme}) => theme.white};
  border: 0.5px solid #DFE0EB;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  z-index: 99;
`;

export const DropdownMenuItem = styled.li`
  padding: 13px 16px;
  cursor: pointer;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: ${({theme}) => theme.gray};
  white-space: nowrap;
  text-align: left;
  transition: all 300ms ease;

  &:hover {
    background: ${({theme}) => theme.accentLightest};
    border-radius: 5px;
    color: ${({theme}) => theme.accent};
  }
`;
